<div class="min-h-[70vh] py-2 px-3">
  <div class="pb-2 flex gap-6 mb-10">
    <app-nav-button [route]="routeBack"></app-nav-button>
    <h2 class="text-2xl font-semibold text-gray-800">Crear oferta de empleo</h2>
  </div>
  <app-loading
    [text]="'Cargando paquetes disponibles'"
    *ngIf="isLoading"
  ></app-loading>
  <div *ngIf="!isLoading">
    <ng-container *ngIf="!selectedPackage">
      <div class="min-h-96">
        <h3 class="text-lg font-semibold text-gray-700 mb-4">
          Selecciona un paquete para publicar tu oferta
        </h3>
        <div
          *ngIf="packages.length === 0"
          class="text-center text-gray-500 py-20"
        >
          <p class="text-lg font-medium">No tienes paquetes disponibles</p>
          <p class="text-sm mt-2">
            Has agotado todas las publicaciones de tus paquetes actuales. Por
            favor, adquiere un nuevo paquete para poder crear una oferta.
          </p>
        </div>
        <div
          *ngIf="packages.length > 0"
          class="grid grid-cols-1 md:grid-cols-3 gap-6"
        >
          <div
            *ngFor="let pkg of packages"
            class="border border-primary rounded-xl p-6 bg-white transition cursor-pointer hover:shadow-md"
            (click)="selectPackage(pkg)"
          >
            <h4 class="text-xl font-bold text-primary mb-2">
              {{ pkg.package.name }}
              <br />
              <span class="font-semibold"
                >{{ pkg.remainingPosts }} publicaciones restantes</span
              >
            </h4>
            <p class="text-gray-600 text-sm">
              Vigencia: {{ pkg.fromProperty | date : "shortDate" }} -
              {{ pkg.until | date : "shortDate" }}
            </p>
            <p
              *ngIf="pkg.discountPercentage && pkg.discountPercentage !== '0'"
              class="text-sm text-green-600 font-semibold mt-2"
            >
              Descuento: {{ pkg.discountPercentage }}%
            </p>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="selectedPackage">
      <div class="flex items-center justify-between mb-6">
        <h3 class="text-lg font-semibold text-gray-700">
          Usando paquete:
          <span class="text-primary">{{ selectedPackage.package.name }}</span>
        </h3>
        <button
          (click)="changePackage()"
          class="text-sm text-primary hover:underline"
        >
          Cambiar paquete
        </button>
      </div>
      <form
        [formGroup]="jobOfferForm.form"
        (ngSubmit)="onSubmit()"
        class="space-y-6"
      >
        <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
          <app-input-select
            label="Departamento"
            placeholder="Seleccione departamento"
            [control]="jobOfferForm.form.get('idDepartament')"
            [options]="departaments"
            (change)="onDepartmentChange($event)"
          >
          </app-input-select>
          <app-input-select
            label="Provincia"
            placeholder="Seleccione provincia"
            [control]="jobOfferForm.form.get('idProvince')"
            [options]="provinces"
            (change)="onProvinceChange($event)"
            [disabled]="jobOfferForm.form.get('idProvince')?.disabled ?? false"
          >
          </app-input-select>
          <app-input-select
            label="Distrito"
            placeholder="Seleccione distrito"
            [control]="jobOfferForm.form.get('idDistrict')"
            [options]="districts"
            [disabled]="jobOfferForm.form.get('idDistrict')?.disabled ?? false"
          >
          </app-input-select>
          <app-input-select
            label="Área"
            placeholder="Seleccione area"
            [control]="jobOfferForm.form.get('idArea')"
            [options]="areas"
          >
          </app-input-select>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
          <app-input-select
            label="Educación"
            placeholder="Seleccione educación"
            [control]="jobOfferForm.form.get('idEducation')"
            [options]="educations"
          >
          </app-input-select>
          <app-input-select
            label="Modalidad de empleo"
            placeholder="Seleccione modalidad"
            [control]="jobOfferForm.form.get('idJobType')"
            [options]="employmentTypes"
          >
          </app-input-select>
          <app-input-select
            label="Título de empleo"
            placeholder="Seleccione título"
            [control]="jobOfferForm.form.get('idJobTitle')"
            [options]="jobTitles"
          >
          </app-input-select>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <app-input-select
            label="Profesión"
            placeholder="Seleccione profesión"
            [control]="jobOfferForm.form.get('idProfession')"
            [options]="professions"
          >
          </app-input-select>
          <app-input-text
            label="Título de oferta"
            placeholder="Ejemplo: Desarrollador web"
            [control]="jobOfferForm.form.get('jobTitle')"
          />
          <app-input-text
            label="Subtítulo"
            placeholder="Ejemplo: Proyecto de tesis"
            [control]="jobOfferForm.form.get('subTitle')"
          />
        </div>
        <div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1"
              >Descripción</label
            >
            <ckeditor
              [editor]="Editor"
              [(ngModel)]="content"
              [config]="editorConfig"
              formControlName="description"
              class="w-full z-0 text-gray-900 placeholder-gray-500 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary editor-area"
            >
            </ckeditor>
          </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-5 gap-6">
          <app-input-text
            label="Edad mínima"
            placeholder="18"
            [control]="jobOfferForm.form.get('minAge')"
          />
          <app-input-text
            label="Edad máxima"
            placeholder=""
            [control]="jobOfferForm.form.get('maxAge')"
          />
          <app-input-text
            label="Experiencia (años)"
            placeholder="1"
            [control]="jobOfferForm.form.get('experience')"
          />
          <app-input-text
            label="Número de vacantes"
            placeholder="10"
            [control]="jobOfferForm.form.get('numberVacancies')"
          />
          <div class="flex items-center gap-2 mt-8">
            <input
              type="checkbox"
              formControlName="hasRemuneration"
              id="hasRemuneration"
              class="accent-primary w-4 h-4"
            />
            <label
              for="hasRemuneration"
              class="text-sm text-gray-700 flex items-center gap-1"
            >
              Tiene remuneración
              <span class="relative group">
                <ng-icon
                  name="heroInformationCircle"
                  class="text-gray-400 w-4 h-4 cursor-pointer"
                ></ng-icon>
                <span
                  class="absolute w-32 left-5 top-1/2 -translate-y-1/2 hidden group-hover:block bg-gray-800 text-white text-xs px-2 py-1 rounded shadow-lg"
                >
                  Indica si este puesto recibirá un pago.
                </span>
              </span>
            </label>
          </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <ng-container *ngIf="hasRemuneration">
            <app-input-text
              label="Salario mínimo"
              placeholder="1200"
              [control]="jobOfferForm.form.get('minSalary')"
            />
            <app-input-text
              label="Salario máximo"
              placeholder="3500"
              [control]="jobOfferForm.form.get('maxSalary')"
            />
            <div class="flex items-center gap-2 mt-8">
              <input
                type="checkbox"
                formControlName="showSalary"
                id="showSalary"
                class="accent-primary w-4 h-4"
              />
              <label
                for="showSalary"
                class="text-sm text-gray-700 flex items-center gap-1"
              >
                Mostrar salario
                <span class="relative group">
                  <ng-icon
                    name="heroInformationCircle"
                    class="text-gray-400 w-4 h-4 cursor-pointer"
                  ></ng-icon>
                  <span
                    class="absolute w-32 left-5 top-1/2 -translate-y-1/2 hidden group-hover:block bg-gray-800 text-white text-xs px-2 py-1 rounded shadow-lg"
                  >
                    Si está activado, el salario será visible en la publicación.
                  </span>
                </span>
              </label>
            </div>
          </ng-container>
        </div>
        <div class="text-right pt-6 w-1/4">
          <app-loading-button
            [text]="'Publicar oferta'"
            [loading]="isSubmitting"
            type="submit"
          >
          </app-loading-button>
        </div>
      </form>
    </ng-container>
  </div>
</div>
